import {useHistory} from "react-router";
import RegisterLayout from "@/layout/RegisterLayout";
import style from './Resiger.scss'
import MButton from "@/components/atom/MButton";
import React from "react";
import RestrictionPanel from "@/components/term/RestrictionPanel";

const Apply = () => {
  const history = useHistory()

  const toRegister = () => {
    history.push('/register/register')
  }

  const goBack = () => {
    history.push('/register/propose')
  }

  return (
    <>
      <RegisterLayout>
        <div className={style.container}>
          <RestrictionPanel/>
          <MButton image={'agree.png'} value={'同意して利用開始'} onClick={toRegister}></MButton>
          <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
        </div>
      </RegisterLayout>
    </>
  )
}

export default Apply;
